module.exports = __webpack_public_path__ + "img/data+.839ac7d0.png";